import Swiper from "swiper";
import { Navigation, Pagination, EffectCards, Autoplay} from "swiper/modules";
import "swiper/css";

const isShopOnHome = document.getElementById("shop-on-home") || null;
let shopOnHome;
let isInit = false;

function initShopOnHomeSlider() {
    if (!isInit) {
        shopOnHome = new Swiper("#shop-on-home", {
            modules: [Pagination, Navigation],
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 30,
            centeredSlides: true,
            allowTouchMove: true,
            initialSlide: parseInt(localStorage.getItem("shopOnHomeActiveSlide")) || 0,
            pagination: {
                el: "#shop-on-home-pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: "#shop-on-home-button-next",
                prevEl: "#shop-on-home-button-prev",
                disabledClass: "border-gray",
            },
            slideNextClass: "opacity-40",
            slidePrevClass: "opacity-40",
            breakpoints: {
                1000: {
                    slidesPerView: 3,
                },
                870: {
                    slidesPerView: 2.5,
                },
                685: {
                    slidesPerView: 2,
                },
                470: {
                    slidesPerView: 1.6,
                },
            },
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
        });
        shopOnHome.on("slideChange", function () {
            localStorage.removeItem("shopOnHomeActiveSlide");
        });
        isInit = true;
    }
}

function checkScreenWidth() {
    if (window.innerWidth <= 1196) {
        initShopOnHomeSlider();
    } else {
        if (isInit) {
            shopOnHome.destroy();
            shopOnHome = null;
            isInit = false;
        }
    }
}

if (isShopOnHome) {
    window.addEventListener("resize", checkScreenWidth);
    window.addEventListener("load", checkScreenWidth);
}

const mainOnHomeEl = document.getElementById("main-on-home");

const MainOnHome = new Swiper("#main-on-home", {
    modules: [Pagination, Navigation, Autoplay],
    pagination: {
        el: "#main-on-home-pagination",
        type: "fraction",
    },
    autoplay: {
        delay: 3000,
    },
    navigation: {
        nextEl: "#main-on-home-button-next",
        prevEl: "#main-on-home-button-prev",
        disabledClass: "border-gray",
    },
    slideNextClass: "opacity-[0.4]",
    slidePrevClass: "opacity-40",
    on: {
        'init': (_swiper) => {
            _swiper.slides.forEach((slide) => {
                slide.addEventListener("click", function (event) {
                    if (!slide.classList.contains("swiper-slide-active")) {
                        event.preventDefault(); // Отменяем переход по ссылке
                        _swiper.slideTo(_swiper.slides.indexOf(slide)); // Делаем слайд активным
                    }
                });
            });
        }
    }
});

if (mainOnHomeEl) {
    window.addEventListener("load", () => {
        mainOnHomeEl.classList.remove("opacity-0");
        mainOnHomeEl.classList.remove("translate-x-[-40px]");
    });
}

const ProductionOnHome = new Swiper("#production-on-home", {
    modules: [Pagination, Navigation],
    grabCursor: true,
    pagination: {
        el: "#production-on-home-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: "#production-on-home-button-next",
        prevEl: "#production-on-home-button-prev",
        disabledClass: "border-gray",
    },
    slidesPerView: 1,
    slideNextClass: "opacity-40",
    slidePrevClass: "opacity-40",
});

const CooperationOnHome = new Swiper("#cooperation-on-home", {
    modules: [Pagination, Navigation],
    grabCursor: true,
    slidesPerView: 1,
    pagination: {
        el: "#cooperation-on-home-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: "#cooperation-on-home-button-next",
        prevEl: "#cooperation-on-home-button-prev",
        disabledClass: "border-gray",
    },
    breakpoints: {
        685: {
            spaceBetween: 80,
            slidesPerView: "auto",
        },
    },
});
const CooperationOnPartners = new Swiper("#cooperation-on-partners", {
    modules: [Pagination, Navigation],
    grabCursor: true,
    slidesPerView: 1,
    pagination: {
        el: "#cooperation-on-partners-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: "#cooperation-on-partners-button-next",
        prevEl: "#cooperation-on-partners-button-prev",
        disabledClass: "border-gray",
    },
    breakpoints: {
        685: {
            spaceBetween: 80,
            slidesPerView: "auto",
        },
    },
});

if (window.innerWidth < 1198) {
    const ReviewsWithoutTextOnHome = new Swiper("#reviews-without-text-on-home", {
        modules: [Pagination, Navigation],
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: "#reviews-without-text-on-home-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: "#reviews-without-text-on-home-button-next",
            prevEl: "#reviews-without-text-on-home-button-prev",
            disabledClass: "border-gray",
        },
        breakpoints: {
            685: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
        },
    });
}

if (window.innerWidth < 1198) {
    const ReviewsOnHome = new Swiper("#reviews-on-home", {
        modules: [Pagination, Navigation],
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
            el: "#reviews-on-home-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: "#reviews-on-home-button-next",
            prevEl: "#reviews-on-home-button-prev",
            disabledClass: "border-gray",
        },
        breakpoints: {
            685: {
                slidesPerView: 2,
            },
        },
    });
}

const FactoryServices = new Swiper("#factory-services", {
    modules: [Navigation],
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 40,
    navigation: {
        nextEl: "#factory-services-button-next",
        prevEl: "#factory-services-button-prev",
        disabledClass: "border-gray",
    },
    breakpoints: {
        685: {
            slidesPerView: 2,
        },
        1196: {
            slidesPerView: "auto",
        },
    },
});

const Service = new Swiper("#service-slider", {
    modules: [Navigation, Pagination],
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 5,
    navigation: {
        nextEl: "#service-button-next",
        prevEl: "#service-button-prev",
        disabledClass: "border-gray",
    },
    pagination: {
        el: "#service-pagination",
        type: "fraction",
    },
    autoHeight: false,
});

const EventSliders = new Swiper("#event-sliders", {
    modules: [Navigation, Pagination],
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
        nextEl: "#event-sliders-button-next",
        prevEl: "#event-sliders-button-prev",
        disabledClass: "border-gray",
    },
    pagination: {
        el: "#event-sliders-pagination",
        type: "fraction",
    },
    breakpoints: {
        685: {
            slidesPerView: 2,
        },
        1196: {
            slidesPerView: "auto",
        },
    },
});

const MainOnCompany = new Swiper("#main-on-company", {
    modules: [Pagination, Navigation],
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 15,
    centeredSlides: true,
    pagination: {
        el: "#main-on-company-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: "#main-on-company-button-next",
        prevEl: "#main-on-company-button-prev",
        disabledClass: "border-gray",
    },
    slideNextClass: "opacity-40",
    slidePrevClass: "opacity-40",
    breakpoints: {
        640: {
            slidesPerView: 1.2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 1.4,
            spaceBetween: 30,
        },
        1440: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
    },
});

const ReviewsSlider = new Swiper("#reviews-slider", {
    modules: [Pagination, Navigation],
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 30,
    centeredSlides: false,
    autoHeight: false,
    pagination: {
        el: "#reviews-slider-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: "#reviews-slider-button-next",
        prevEl: "#reviews-slider-button-prev",
        disabledClass: "border-gray",
    },
    breakpoints: {
        685: {
            slidesPerView: 2,
        },
        1196: {
            slidesPerView: 3,
        },
    },
    grid: {
        rows: 2,
    },
});

var companyImage = new Swiper("#company-image", {
    modules: [EffectCards],
    effect: "cards",
    grabCursor: true,
});

var companyText = new Swiper("#company-text", {
    modules: [Pagination, Navigation],
    grabCursor: true,
    pagination: {
        el: "#company-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: "#company-button-next",
        prevEl: "#company-button-prev",
        disabledClass: "border-gray",
    },
});

companyText.on("slideChange", () => {
    companyImage.slideTo(companyText.activeIndex);
});
companyImage.on("slideChange", () => {
    companyText.slideTo(companyImage.activeIndex);
});
